import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/node/app/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import { Form, TextInput, TextArea, Button } from "carbon-components-react";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`Interested in working together? Let’s talk.`}</p>
    </PageDescription>
    <Form action="https://formspree.io/f/mrgdlvpg" method="POST" mdxType="Form">
      <TextInput helperText="" required="true" id="email" name="email" type="email" invalidText="Invalid email." labelText="Email" placeholder="Your email" mdxType="TextInput" />
      <TextArea cols={50} helperText="" required="true" id="message" name="Message" invalidText="Invalid message." labelText="message" placeholder="Your message" rows={4} mdxType="TextArea" />
      <Button kind="primary" type="submit" mdxType="Button">
Send to Bill
      </Button>
    </Form>
    {/*
     <p>
     Bill Alive<br />
     1029 Lyell Ave PMB 314<br />
     Rochester, NY 14606
     </p>
     */}

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      